import { useEffect, useState } from "react";
import { Inbox, IndianRupee, Users, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { AdminHeading, Card } from "@/components/admin/ui";

export default function Overview({ onNavigate }) {
  const { admin, can } = useAdminAuth();
  const [o, setO] = useState(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setO(r.data)).catch(() => setO({})); }, []);
  const stats = [
    { label: "New enquiries", value: o?.enquiries_new, icon: Inbox, tab: "enquiries", perm: "enquiries" },
    { label: "Active scrap rates", value: o?.rates_active, icon: IndianRupee, tab: "rates", perm: "rates" },
    { label: "Admin users", value: o?.admins, icon: Users, tab: "users", perm: "users" },
  ].filter((s) => can(s.perm));

  return (
    <div data-testid="admin-overview">
      <AdminHeading title={`Namaste, ${admin.name.split(" ")[0]}`} subtitle="Here's a quick look at the website." />
      <div className="grid sm:grid-cols-3 gap-4">
        {stats.map(({ label, value, icon: Icon, tab }) => (
          <Card key={label} className="p-5 card-lift cursor-pointer" onClick={() => onNavigate(tab)} data-testid={`overview-stat-${tab}`}>
            <div className="flex items-center justify-between"><Icon className="text-[var(--leaf)]" size={20} /><ArrowRight size={16} className="text-[var(--ink-soft)]" /></div>
            <div className="mt-4 font-display text-4xl font-bold">{value ?? "—"}</div>
            <div className="text-sm text-[var(--ink-soft)]">{label}</div>
          </Card>
        ))}
      </div>
      <Card className="p-6 mt-6">
        <h2 className="font-bold text-lg">What you can do</h2>
        <ul className="mt-3 text-sm text-[var(--ink-soft)] space-y-1.5 list-disc pl-5">
          {can("rates") && <li>Update scrap rates — changes are live instantly on the website and in Prana's answers.</li>}
          {can("content") && <li>Edit the hero text, announcement bar, contact details, app links and FAQs.</li>}
          {can("enquiries") && <li>Review contact-form enquiries and city requests.</li>}
          {can("users") && <li>Create team logins and assign roles.</li>}
        </ul>
      </Card>
    </div>
  );
}
